const timerElements = document.querySelectorAll("#pdp-timer-element");

// Loop through each timer element and initialize the timer
timerElements.forEach(timerElement => {
    const customDate = timerElement.getAttribute("data-timer"); // e.g., "12-Oct-2024 13:00:00"

    // Parse the custom date into a format JavaScript can understand
    const parsedDate = new Date(Date.parse(customDate.replace(/-/g, " "))).getTime();

	// Get the parent container for the timer
    const timerContainer = document.querySelector(".timer-setup-container");

    // Countdown function for each timer element
    const countdownFunction = setInterval(() => {
        const now = new Date().getTime(); // Get the current time
        const distance = parsedDate - now; // Calculate the time remaining

        // Calculate days, hours, minutes, and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const totalHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Determine label text based on plural or singular
        const dayLabel = days === 1 ? 'Day' : 'Days';
        const hourLabel = totalHours === 1 ? 'Hr' : 'Hrs';
        const minuteLabel = minutes === 1 ? 'Min' : 'Mins';
        const secondLabel = seconds === 1 ? 'Sec' : 'Secs';

        // Display the time in the format: dd:hh:mm:ss  
        timerElement.innerHTML = `
            <div class="timer-numbers">
                <div>${String(days).padStart(2, '0')} :</div>
                <div>${String(totalHours).padStart(2, '0')} :</div>
                <div>${String(minutes).padStart(2, '0')} :</div>
                <div>${String(seconds).padStart(2, '0')}</div>
            </div>
            <div class="timer-labels">
                <div class="timer-label">${dayLabel}</div>
                <div class="timer-label">${hourLabel}</div>
                <div class="timer-label">${minuteLabel}</div>
                <div class="timer-label">${secondLabel}</div>
            </div>
        `;

        // If the countdown is finished, hide the timer and set the time to "00:00:00:00"
        if (distance < 0) {
            clearInterval(countdownFunction);
            timerElement.innerHTML = ``;
			timerContainer.classList.add('d-none');
        }
    }, 1000);
});

 